// tokenCurrency.ts
import Currency from '@/types/Currency'

export const CurrencyList = [
	{
		slug: 'bpx',
		name: 'Reward Miles',
		name_short: 'Miles',
		decimals: 9,
	},
	{
		slug: 'q12025-break-cred',
		name: 'Break Credits (Break #1)',
		name_short: 'Credits',
		decimals: 2,
	},
	{
		slug: 'hth-baseball-2025-drop-2-break-cred',
		name: 'Break Credits (Break #2)',
		name_short: 'Credits',
		decimals: 2,
	},
	{
		slug: 'hth-baseball-2025-drop-2-break-cred',
		name: 'Break Credits',
		name_short: 'Credits',
		decimals: 2,
	},
]

export const tokenCurrency = function (tokenSlug: string, isLong: boolean = false): string {
	let currency

	try {
		currency = Currency.makeBySlug(tokenSlug)
	} catch (e) {
		currency = Currency.defaultCurrency()
	}

	return isLong ? currency.name() : currency.nameShort()
} as TokenFunction

export interface TokenFunction {
	(slug: string, isLong?: boolean): string
	value: string
	toString(): string
}

// attach string behavior so we dont have to refactor {{ $token }} everywhere
tokenCurrency.value = CurrencyList[0].name_short
tokenCurrency.toString = () => tokenCurrency.value
